import { Stack } from "@mui/material";
import {
  templateFiltersDefaultValue,
  useTemplateFilterFields,
} from "./TemplateFilterFields.js";

export { templateFiltersDefaultValue };

type Props = Omit<Parameters<typeof useTemplateFilterFields>[0], "viewType">;

export const TemplateFilters = ({ formikProps, ...props }: Props) => {
  const { nonPropertyFields } = useTemplateFilterFields({
    ...props,
    formikProps,
    viewType: "buttons",
  });

  return nonPropertyFields.length > 0 ? (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={{
        flexWrap: "wrap",
        alignItems: "center",
        minHeight: "32px",
      }}
    >
      {nonPropertyFields}
    </Stack>
  ) : null;
};
